import { Component, Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProgressLoaderComponent } from '../components/common/progress-loader/progress-loader.component';

@Injectable({
  providedIn: 'root'
})
export class ProgressLoaderService {
  private dialogRef: DynamicDialogRef | null = null;

  constructor(private dialogService: DialogService) {}

  show(title: string = 'Loading') {
    this.dialogRef = this.dialogService.open(ProgressLoaderComponent, {
      width: '300px',
      closable: false,
      closeOnEscape: false,
      dismissableMask: false,
      showHeader: false, 
      styleClass: 'progress-loader-dialog',
      data: { title: title }
    });
  }

  hide() {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
